var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"library-icon",class:`library-icon--${_vm.library}`,attrs:{"src":_vm.iconSrc,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }